import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  CampaignStatusComponent,
  NgPrincipleSharedModule,
} from '@principle-theorem/ng-principle-shared';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AcquisitionsModule } from './acquisitions/acquisitions.module';
import { ReportingCoreModule } from './core/reporting-core.module';
import { CustomReportResolverService } from './custom-reports/custom-report-resolver.service';
import { ReportRunResolverService } from './custom-reports/report-run-resolver.service';
import { CustomReportFilterComponent } from './custom-reports/custom-report/custom-report-filters/custom-report-filter/custom-report-filter.component';
import { DataSourceDisplayComponent } from './custom-reports/custom-report/data-source-display/data-source-display.component';
import { EditReportFilterDialogComponent } from './custom-reports/custom-report/edit-report-filter-dialog/edit-report-filter-dialog.component';
import { PreSelectedFiltersComponent } from './custom-reports/custom-report/pre-selected-filters/pre-selected-filters.component';
import { QueryableTimestampDisplayComponent } from './custom-reports/custom-report/queryable-timestamp-display/queryable-timestamp-display.component';
import { CustomReportsService } from './custom-reports/custom-reports.service';
import { HasAccessToCustomReportGuard } from './custom-reports/has-access-to-custom-report.guard';
import { DailyDashboardComponent } from './daily-dashboard/daily-dashboard.component';
import { LegacyReportsModule } from './legacy-reports/legacy-reports.module';
import { PatientFlowModule } from './patient-flow/patient-flow.module';
import { PracticeIncomeComponent } from './practice-reporting/practice-income/practice-income.component';
import { PracticeOperationsComponent } from './practice-reporting/practice-operations/practice-operations.component';
import { PracticePatientsComponent } from './practice-reporting/practice-patients/practice-patients.component';
import { PracticeProductivityComponent } from './practice-reporting/practice-productivity/practice-productivity.component';
import { PracticeReportingComponent } from './practice-reporting/practice-reporting.component';
import { PractitionerReportingModule } from './practitioner-reporting/practitioner-reporting.module';
import { ReportBuilderChartComponent } from './report-builder/report-builder-chart-filters/report-builder-chart-section/report-builder-chart/report-builder-chart.component';
import { ReportBuilderDataPointSelectorComponent } from './report-builder/report-builder-data-point-selector/report-builder-data-point-selector.component';
import { ReportBuilderMoveToSectionDialogComponent } from './report-builder/report-builder-move-to-section-dialog/report-builder-move-to-section-dialog.component';
import { ReportBuilderAddChartDialogComponent } from './report-builder/report-builder-results-table/report-builder-add-chart-dialog/report-builder-add-chart-dialog.component';
import { ReportBuilderColumnSelectorDialogComponent } from './report-builder/report-builder-results-table/report-builder-column-selector-dialog/report-builder-column-selector-dialog.component';
import { ReportBuilderEditGroupByDialogComponent } from './report-builder/report-builder-results-table/report-builder-edit-group-by-dialog/report-builder-edit-group-by-dialog.component';
import { ReportBuilderTableNameDialogComponent } from './report-builder/report-builder-results-table/report-builder-table-name-dialog/report-builder-table-name-dialog.component';
import { ReportBuilderStore } from './report-builder/report-builder.store';
import { ReportEditorService } from './report-builder/report-editor.service';
import { ReportingComponentsModule } from './reporting-components/reporting-components.module';
import { SystemReportsComponent } from './system-reports/system-reports.component';

/**
 * @deprecated
 * Import specific standalone components and utility modules instead.
 */
@NgModule({
  imports: [
    CommonModule,
    NgSharedModule,
    NgPrincipleSharedModule,
    ReportingCoreModule,
    ReportingComponentsModule,
    PatientFlowModule,
    AcquisitionsModule,
    PractitionerReportingModule,
    LegacyReportsModule,
    SystemReportsComponent,
    PreSelectedFiltersComponent,
    CampaignStatusComponent,
    DataSourceDisplayComponent,
    QueryableTimestampDisplayComponent,
    EditReportFilterDialogComponent,
    CustomReportFilterComponent,
    ReportBuilderDataPointSelectorComponent,
    ReportBuilderChartComponent,
    NgxMatSelectSearchModule,
  ],
  declarations: [
    PracticeReportingComponent,
    DailyDashboardComponent,
    PracticeIncomeComponent,
    PracticePatientsComponent,
    PracticeOperationsComponent,
    PracticeProductivityComponent,
    ReportBuilderColumnSelectorDialogComponent,
    ReportBuilderTableNameDialogComponent,
    ReportBuilderAddChartDialogComponent,
    ReportBuilderEditGroupByDialogComponent,
    ReportBuilderMoveToSectionDialogComponent,
  ],
  exports: [
    ReportingComponentsModule,
    PatientFlowModule,
    PreSelectedFiltersComponent,
  ],
  providers: [
    ReportBuilderStore,
    CustomReportResolverService,
    ReportRunResolverService,
    HasAccessToCustomReportGuard,
    CustomReportsService,
    ReportEditorService,
  ],
})
export class ReportingModule {}
